<app-navbartwo></app-navbartwo>
<section class="feat_main_bg">
  <div class="container">
    <!-- section of the page in header section2 -->
    <div class="row" style="padding-bottom: 40px;">
      <div class="col-md-5">
        <div class="banner_right">
        <h5 class="banner_text_main">Contact - Us</h5>
         <p class="section_top">
          Your business is now our business! Come, let’s make it a success! <br>
           <br>
          We offer the perfect digital commerce solutions to ensure that your vision
         to set a trend is successfully completed. It is our mission to also ensure
         that crisis are dealt with innovatively and efficiently.
         </p>
         </div>
      </div>
      <div class="col-md-7">
        <div>
          <img src="../../assets/images/contactus_1.png" alt="video_image" class="video_image">
        </div>
    </div>
    </div>
    <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
      <path fill="#0099ff" fill-opacity="1" d="M 50 200 Q 100 300 250 300 Q 600 250 750 200 "></path>
    </svg> -->
  </div>
</section>

<!-- section of the page in header section2 End -->
<section style="background-color: #fff; padding-bottom: 40px;">
  <div class="container">

        <p class="psection_two" style="padding-top:40px;">
          Questions, Queries, Concerns or just plain Curious?! Call us or write to us! We will be in touch!<br>
          Whether you want to put your retail business online, or start a new business afresh online, or want
           to know how we could be of assistance to you; all you have to do is contact us. We will get in touch
           with you to take it further.
        </p>

      <div class="row">
          <div class="col-md-12 col-lg-6 form_section">
              <div class="contact_lefts">
                  <img src="../../../assets/images/contactones1.png" alt="contactblueimage" class="conatactblue" />
                  <!-- <img src="../../../assets/images/conatctred1.png" alt="contactredimage" class="conatactred" /> -->
                  <div style="padding-top: 25px;">
                      <form class="conatact_form" style="padding: 30px;" class="contactform" [formGroup]="contactform" (ngSubmit)="submitForm()">
                          <div class="form-row">
                              <div class="col-md-6 contact_gap">
                                  <input type="text" class="form-control" placeholder="Name" formControlName="Name"  name="Name" style="color: black;
                                  background-color: #dcdcdc69;">
                                  <span style="font-weight: bold;color: red;font-size: 14PX;"  *ngIf="!contactform.controls['Name'].valid&&contactform.controls['Name'].dirty&&contactform.controls['Name'].enabled">
                                    <span *ngIf="contactform.controls.Name.errors.required"> Name is Required.</span>
                                  </span>
                                </div>
                              <div class="col-md-6 contact_gap">
                                  <input type="text" class="form-control" placeholder="Email" formControlName="Email"  name="Email" style="color: black;
                                  background-color: #dcdcdc69;">
                                  <span style="font-weight: bold;color: red;font-size: 14PX;"  *ngIf="!contactform.controls['Email'].valid&&contactform.controls['Email'].dirty">
                                    <span *ngIf="contactform.controls.Name.errors.required"> Email is Required.</span>
                                    <span style="font-weight: bold;color: red;" *ngIf="!contactform.controls['Email'].valid&&contactform.controls['Email'].dirty">
                                      <span *ngIf="contactform.controls.Email.errors.email">Email is not vaild.</span>
                                    </span>
                                  </span>
                                </div>
                          </div>
                          <div class="form-row">
                            <div class="col-md-6 contact_gap">
                              <input type="text" class="form-control" placeholder="Phone Number" formControlName="MobileNo" maxlength="10" name="phonenumber" style="color: black;
                              background-color: #dcdcdc69;">
                              <span style="font-weight: bold;color: red;font-size: 14PX;"  *ngIf="!contactform.controls['MobileNo'].valid&&contactform.controls['MobileNo'].dirty">
                                <span *ngIf="contactform.controls.MobileNo.errors.required">Mobile Number is Required.</span>
                                <span *ngIf="contactform.controls.MobileNo.errors.minlength">Mobile Number should be length of 10.</span>
                                 </span>
                            </div>
                              <div class="col-md-6 contact_gap">
                                  <input type="text" class="form-control" placeholder="Your Subject" formControlName="Subject"  name="Subject" style="color: black;
                                  background-color: #dcdcdc69;">
                                  <span style="font-weight: bold;color: red;font-size: 14PX;"  *ngIf="!contactform.controls['Subject'].valid&&contactform.controls['Subject'].dirty">
                                    <span *ngIf="contactform.controls.Subject.errors.required">Subject is Required.</span>
                                     </span>
                              </div>
                          </div>
                          <div class="form-row">
                              <div class="col contact_gap">
                                  <textarea type="text" class="form-control" placeholder="Message" formControlName="Message"  name="Message" rows="4" style="height: 124px;" style="color: black;
                                  background-color: #dcdcdc69;"></textarea>
                                </div>
                          </div>
                          <div class="form-row" style=" margin-bottom: 20px;">
                              <button type="submit" [disabled]="!contactform.valid" class="btn sendmessage_button" >Send Message</button>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
          <div class="col-md-12 col-lg-4 leftconacts">
            <div>
              <img src="../../assets/images/contact_right.png" alt="landing_contactus" class="contact_landing_page">
            </div>
          </div>
      </div>
      <br>
      <div class="message_box" >
        <div class="row">
          <div class="planning_topdivss">
          <h4 class="h4_heading" style="color:#fff">Start selling Your Business with MCred</h4>
          <button class="getstarted_button">Get Started</button>
          </div>
        </div>
      </div>
    </div>
</section>

<!--section of the page in header section8  End-->

   <!-- section of the page in header section8  -->

  <!-- section of the page in header section8  End-->
<!-- end contact Area -->
<app-footer></app-footer>

